module.exports = {
      id: "carteira-sem-saldo-usage",
      viewBox: "0 0 316 299",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#carteira-sem-saldo",
      toString: function () {
        return this.url;
      }
    }